module.exports = __webpack_public_path__ + "static/images/banner-phone2.a32f33b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/banner-phone2.jpg
// module id = 238
// module chunks = 1